import { useEffect, useState } from "react";
import { baseUrl, headersDefault } from "../redux/actions";

/**
 * The head of «Percorsi nutrizionali», as configured in the CRM:
 * - `video`: the video of the page («Come funzionano i percorsi?»);
 * - `adocVideo`: the nutritionist's video in the aDòc popup («Quando
 *   scegliere aDòc?»), null on a backend that doesn't send it yet;
 * - `adocRoute`: the copy of the old Personalizzato aDòc card (unused since
 *   the aDòc banner, 28/10/2026);
 * - `premiumLite`: for a Premium Lite member, their main journey and 72-hour
 *   choice window ({ main_protocol_id, main_protocol_name, window_open,
 *   window_ends_at, special_protocol_ids }).
 *
 * Its own small request rather than a field on the protocol list: that endpoint
 * answers with a bare array and every app version in the field expects it to
 * stay one. Kept outside redux because nothing else needs the values.
 *
 * All are null until known; video stays null when none is configured (the card
 * is not drawn), adocRoute fields stay null to use the app default, and
 * premiumLite stays null for everyone but Premium Lite.
 */
export default function useProtocolsPageHeader(enabled = true) {
  const [header, setHeader] = useState({
    video: null,
    adocVideo: null,
    adocRoute: null,
    premiumLite: null,
  });

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    // Guards the state update: the member can leave the tab mid-flight, and a
    // set on an unmounted screen is a warning at best and a leak at worst.
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/v1/master-club-nutritional-goals/page-header`,
          { headers: headersDefault() },
        );
        if (!res.ok) return;

        const data = await res.json();
        if (!cancelled) {
          setHeader({
            video: data?.video ?? null,
            adocVideo: data?.adoc_video ?? null,
            adocRoute: data?.adoc_route ?? null,
            premiumLite: data?.premium_lite ?? null,
          });
        }
      } catch {
        // Nothing here is worth an error to the member: the rest of the screen
        // is the point, so this stays silent and draws nothing.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return header;
}
